import axios from "axios";

const baseURL = import.meta.env.PROD
  ? (import.meta.env.VITE_CALLPASS_API_URL || "")
  : (import.meta.env.VITE_CALLPASS_API_URL || "");

export const callpassApi = axios.create({
  baseURL,
  timeout: 30000,
  headers: { "Content-Type": "application/json" },
});

callpassApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("authToken");
  if (token && config.headers) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

callpassApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("userInfo");
      window.location.href = "/login";
      return new Promise(() => {});
    }

    const message =
      error.response?.data?.message ||
      error.response?.data?.Message ||
      (error.request ? "서버에 연결할 수 없습니다." : error.message);

    return Promise.reject(new Error(message));
  },
);
